import type {
  TemplateWindowAppearance,
  TextureAppearance,
} from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';
import { FeaturedTemplateVariations } from 'src/modules/designStudio/helpers/data/TemplateFeaturedVariations';

export type TemplatePaletteConfig = {
  paletteName?: string;
  wallAppearances?: {
    walls: TextureAppearance;
    trims?: TextureAppearance;
  }[];
  trimAppearances?: TextureAppearance[];
  roofAppearances?: TextureAppearance[];
  windowAppearances?: TemplateWindowAppearance[];
};

const palette1 = {
  paletteName: 'Arctic Chill',
  wallAppearances: [
    {
      walls: {
        color: '#dfe0dd',
      },
      trims: {
        color: '#dfe0dd',
      },
    },
  ],
  roofAppearances: [FeaturedTemplateVariations.C],
};

const palette2 = {
  paletteName: 'Sleek Onyx',
  wallAppearances: [
    {
      walls: {
        color: '#dfe0dd',
      },
      trims: {
        color: '#434447',
      },
    },
  ],
  roofAppearances: [FeaturedTemplateVariations.C],
};

const palette4 = {
  paletteName: 'Dark Earth',
  wallAppearances: [
    {
      walls: {
        color: '#434447',
      },
      trims: {
        color: '#434447',
      },
    },
  ],
  roofAppearances: [FeaturedTemplateVariations.C],
};

const palette5 = {
  paletteName: 'Misty Morning',
  wallAppearances: [
    {
      walls: {
        color: '#737e83',
      },
      trims: {
        color: '#dfe0dd',
      },
    },
  ],
  roofAppearances: [FeaturedTemplateVariations.C],
};

const palette6 = {
  paletteName: 'Minimalist Grey',
  wallAppearances: [
    {
      walls: {
        color: '#b2aeab',
      },
      trims: {
        color: '#dfe0dd',
      },
    },
  ],
  roofAppearances: [FeaturedTemplateVariations.E],
};

const palette7 = {
  paletteName: 'Desert Sands',
  wallAppearances: [
    {
      walls: {
        color: '#857d72',
      },
      trims: {
        color: '#dfe0dd',
      },
    },
  ],
  roofAppearances: [FeaturedTemplateVariations.D],
};

const palette8 = {
  paletteName: 'Soft Sandstone',
  wallAppearances: [
    {
      walls: {
        color: '#686456',
      },
      trims: {
        color: '#dfe0dd',
      },
    },
  ],
  roofAppearances: [FeaturedTemplateVariations.D],
};

const palette9 = {
  paletteName: 'Gentle Grey',
  wallAppearances: [
    {
      walls: {
        color: '#b5b9b5',
      },
      trims: {
        color: '#dfe0dd',
      },
    },
  ],
  roofAppearances: [FeaturedTemplateVariations.H],
};

const palette10 = {
  paletteName: 'Antique Ivory',
  roofAppearances: [FeaturedTemplateVariations.F],
  wallAppearances: [
    {
      walls: {
        color: '#d8cfc3',
      },
      trims: {
        color: '#dfe0dd',
      },
    },
  ],
};

const palette11 = {
  paletteName: 'Muted Olive',
  roofAppearances: [FeaturedTemplateVariations.D],
  wallAppearances: [
    {
      walls: {
        color: '#aba69e',
      },
      trims: {
        color: '#dfe0dd',
      },
    },
  ],
};

const palette12 = {
  paletteName: 'Subtle Moss',
  roofAppearances: [FeaturedTemplateVariations.G],
  wallAppearances: [
    {
      walls: {
        color: '#a1a797',
      },
      trims: {
        color: '#c8c0b4',
      },
    },
    {
      walls: {
        color: '#7b7873',
      },
    },
    {
      walls: {
        color: '#a1a797',
      },
    },
  ],
};

const palette13 = {
  paletteName: 'Winter Breeze',
  roofAppearances: [FeaturedTemplateVariations.C],
  wallAppearances: [
    {
      walls: {
        color: '#dfe0dd',
      },
      trims: {
        color: '#434447',
      },
    },
    {
      walls: {
        color: '#434447',
      },
    },
    {
      walls: {
        color: '#dfe0dd',
      },
    },
  ],
};

const palette14 = {
  paletteName: 'Midnight Mist',
  roofAppearances: [FeaturedTemplateVariations.C],
  wallAppearances: [
    {
      walls: {
        color: '#434447',
      },
      trims: {
        color: '#434447',
      },
    },
    {
      walls: {
        color: '#dfe0dd',
      },
    },
    {
      walls: {
        color: '#434447',
      },
    },
  ],
};

const palette15 = {
  paletteName: 'Rustic Tones',
  roofAppearances: [FeaturedTemplateVariations.F],
  wallAppearances: [
    {
      walls: {
        color: '#b2aeab',
      },
      trims: {
        color: '#dfe0dd',
      },
    },
    {
      walls: {
        color: '#7b7873',
      },
    },
    {
      walls: {
        color: '#b2aeab',
      },
    },
  ],
};

const palette16 = {
  paletteName: 'Driftless Valley',
  roofAppearances: [FeaturedTemplateVariations.D],
  wallAppearances: [
    {
      walls: {
        color: '#686456',
      },
      trims: {
        color: '#434447',
      },
    },
    {
      walls: {
        color: '#434447',
      },
    },
    {
      walls: {
        color: '#595a4c',
      },
    },
  ],
};

export const SIMPLE_PALETTES: TemplatePaletteConfig[] = [
  palette1,
  palette2,
  palette4,
  palette5,
  palette6,
  palette7,
  palette8,
  palette9,
  palette10,
  palette11,
];

export const ACCENTED_PALETTES: TemplatePaletteConfig[] = [
  palette12,
  palette13,
  palette14,
  palette15,
  palette16,
];
